export default "__VITE_ASSET__BX_W8TZP__"